import { io } from "socket.io-client";

// Extract base URL from REACT_APP_BACKEND_LINK by removing the /api... part
const baseURL = process.env.REACT_APP_BACKEND_LINK 
    ? process.env.REACT_APP_BACKEND_LINK.split("/api")[0] 
    : "";

export const socket = io(baseURL, {
  autoConnect: false,
  transports: ["websocket"],
});